<!-- Cookie Consent Banner -->
<div *ngIf="isVisible" class="cookie-consent-overlay">
  <div class="cookie-consent-banner">
    <!-- Main Banner (Always Visible) -->
    <div class="cookie-banner-main">
      <div class="cookie-content">
        <div class="cookie-icon">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-brocom-orange" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        
        <div class="cookie-text">
          <h3 class="cookie-title">{{ '🍪 Używamy plików cookies' | translate }}</h3>
          <p class="cookie-description">
            {{ 'Używamy plików cookies, aby usprawniać korzystanie z serwisu, personalizować treści i analizować ruch.\n            Klikając „Akceptuj wszystkie”, wyrażasz zgodę na ich używanie.' | translate }}
            <button class="learn-more-btn" (click)="toggleDetails()">
              {{ showDetails ? 'Pokaż mniej' : 'Dowiedz się więcej' }}
            </button>
          </p>
        </div>
      </div>

      <div class="cookie-actions">
        <button class="btn-necessary" (click)="acceptNecessary()">
          {{ 'Tylko niezbędne' | translate }}
        </button>
        <button class="btn-customize" (click)="toggleDetails()">
          {{ 'Dostosuj' | translate }}
        </button>
        <button class="btn-accept-all" (click)="acceptAll()">
          {{ 'Akceptuj wszystkie' | translate }}
        </button>
      </div>
    </div>

    <!-- Detailed Preferences (Collapsible) -->
    <div *ngIf="showDetails" class="cookie-details" [@slideInOut]="'in'" #cookieDetails>
      <div class="cookie-categories">
        <h4 class="details-title">{{ 'Ustawienia plików cookies' | translate }}</h4>
        <p class="details-description">
          {{ 'Wybierz pliki cookies, na których używanie wyrażasz zgodę. Ustawienia możesz zmienić w dowolnym momencie.' | translate }}
        </p>

        <!-- Necessary Cookies -->
        <div class="cookie-category">
          <div class="category-header">
            <div class="category-info">
              <div class="toggle-wrapper">
                <input 
                  type="checkbox" 
                  id="necessary" 
                  [(ngModel)]="cookieConsent.necessary" 
                  disabled 
                  class="cookie-toggle">
                <label for="necessary" class="toggle-label"></label>
              </div>
              <div class="category-text">
                <h5>{{ 'Niezbędne pliki cookies' | translate }}</h5>
                <p>{{ 'Są konieczne do prawidłowego działania strony i nie można ich wyłączyć.' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="category-details">
            <ul>
              <li><strong>{{ 'Uwierzytelnianie:' | translate }}</strong> {{ 'Zapamiętanie statusu logowania (clientToken, clientUser)' | translate }}</li>
              <li><strong>{{ 'Bezpieczeństwo:' | translate }}</strong> {{ 'Ochrona przed nieuprawnionym dostępem i atakami' | translate }}</li>
              <li><strong>{{ 'Sesja:' | translate }}</strong> {{ 'Utrzymanie sesji podczas przechodzenia między stronami' | translate }}</li>
              <li><strong>{{ 'Koszyk:' | translate }}</strong> {{ 'Zapamiętanie produktów w koszyku' | translate }}</li>
            </ul>
          </div>
        </div>

        <!-- Functional Cookies -->
        <div class="cookie-category">
          <div class="category-header">
            <div class="category-info">
              <div class="toggle-wrapper">
                <input 
                  type="checkbox" 
                  id="functional" 
                  [(ngModel)]="cookieConsent.functional" 
                  class="cookie-toggle">
                <label for="functional" class="toggle-label"></label>
              </div>
              <div class="category-text">
                <h5>{{ 'Funkcjonalne pliki cookies' | translate }}</h5>
                <p>{{ 'Ułatwiają korzystanie z dodatkowych funkcji i personalizację serwisu.' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="category-details">
            <ul>
              <li><strong>{{ 'Preferencje:' | translate }}</strong> {{ 'Zapamiętanie ustawień języka i regionu' | translate }}</li>
              <li><strong>{{ 'Ustawienia interfejsu:' | translate }}</strong> {{ 'Zapamiętanie położenia paneli bocznych i preferencji motywu' | translate }}</li>
              <li><strong>{{ 'Dane formularzy:' | translate }}</strong> {{ 'Zapamiętanie wpisanych informacji, aby zapobiec ich utracie' | translate }}</li>
              <li><strong>{{ 'Czat:' | translate }}</strong> {{ 'Obsługa funkcji czatu z działem obsługi klienta' | translate }}</li>
            </ul>
          </div>
        </div>

        <!-- Analytics Cookies -->
        <div class="cookie-category">
          <div class="category-header">
            <div class="category-info">
              <div class="toggle-wrapper">
                <input 
                  type="checkbox" 
                  id="analytics" 
                  [(ngModel)]="cookieConsent.analytics" 
                  class="cookie-toggle">
                <label for="analytics" class="toggle-label"></label>
              </div>
              <div class="category-text">
                <h5>{{ 'Analityczne pliki cookies' | translate }}</h5>
                <p>{{ 'Pomagają nam zrozumieć, w jaki sposób użytkownicy korzystają z serwisu.' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="category-details">
            <ul>
              <li><strong>{{ 'Google Analytics:' | translate }}</strong> {{ 'Analiza odsłon, zachowań użytkowników i wydajności serwisu' | translate }}</li>
              <li><strong>{{ 'Statystyki korzystania:' | translate }}</strong> {{ 'Ustalanie, które funkcje są najpopularniejsze' | translate }}</li>
              <li><strong>{{ 'Monitorowanie błędów:' | translate }}</strong> {{ 'Wykrywanie i usuwanie problemów technicznych' | translate }}</li>
              <li><strong>{{ 'Wydajność:' | translate }}</strong> {{ 'Optymalizacja czasu ładowania i wygody korzystania z serwisu' | translate }}</li>
            </ul>
          </div>
        </div>

        <!-- Marketing Cookies -->
        <div class="cookie-category">
          <div class="category-header">
            <div class="category-info">
              <div class="toggle-wrapper">
                <input 
                  type="checkbox" 
                  id="marketing" 
                  [(ngModel)]="cookieConsent.marketing" 
                  class="cookie-toggle">
                <label for="marketing" class="toggle-label"></label>
              </div>
              <div class="category-text">
                <h5>{{ 'Marketingowe pliki cookies' | translate }}</h5>
                <p>{{ 'Służą do wyświetlania dopasowanych reklam i mierzenia skuteczności kampanii.' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="category-details">
            <ul>
              <li><strong>{{ 'Meta Pixel:' | translate }}</strong> {{ 'Pomiar konwersji i optymalizacja kampanii reklamowych' | translate }}</li>
              <li><strong>{{ 'Google Ads:' | translate }}</strong> {{ 'Wyświetlanie dopasowanych reklam' | translate }}</li>
              <li><strong>{{ 'Remarketing:' | translate }}</strong> {{ 'Wyświetlanie odpowiednich reklam w innych serwisach' | translate }}</li>
              <li><strong>{{ 'Pomiar konwersji:' | translate }}</strong> {{ 'Ocena skuteczności kampanii marketingowych' | translate }}</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Action Buttons for Details -->
      <div class="cookie-actions-detailed">
        <button class="btn-privacy" (click)="openPrivacyPolicy()">
          {{ 'Polityka prywatności' | translate }}
        </button>
        <button class="btn-save" (click)="savePreferences()">
          {{ 'Zapisz ustawienia' | translate }}
        </button>
        <button class="btn-accept-all" (click)="acceptAll()">
          {{ 'Akceptuj wszystkie' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
